import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage'; // @ts-expect-error svg import

import BOTTOM_LEFT_YOLK from 'bender-url!pricing-pages-ui/img/splash-page/bottom-left-yolk.svg'; // @ts-expect-error svg import

import BOTTOM_RIGHT_YOLK from 'bender-url!pricing-pages-ui/img/splash-page/bottom-right-yolk.svg'; // @ts-expect-error svg import

import TOP_LEFT_YOLK from 'bender-url!pricing-pages-ui/img/splash-page/top-left-yolk.svg'; // @ts-expect-error svg import

import TOP_RIGHT_YOLK from 'bender-url!pricing-pages-ui/img/splash-page/top-right-yolk.svg';
const BannerContainer = styled.header.withConfig({
  displayName: "SplashPageBanner__BannerContainer",
  componentId: "sc-1930fl6-0"
})(["position:relative;width:100%;height:250px;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
const Yolks = styled.div.withConfig({
  displayName: "SplashPageBanner__Yolks",
  componentId: "sc-1930fl6-1"
})(["position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;overflow:hidden;"]);
const StyledYolk = styled(UIImage).withConfig({
  displayName: "SplashPageBanner__StyledYolk",
  componentId: "sc-1930fl6-2"
})(["position:absolute;"]);

const SplashPageBanner = ({
  children,
  style
}) => {
  return /*#__PURE__*/_jsxs(BannerContainer, {
    style: style,
    children: [/*#__PURE__*/_jsxs(Yolks, {
      children: [/*#__PURE__*/_jsx(StyledYolk, {
        src: TOP_LEFT_YOLK,
        style: {
          top: 0,
          left: 0
        }
      }), /*#__PURE__*/_jsx(StyledYolk, {
        src: BOTTOM_LEFT_YOLK,
        style: {
          bottom: '-4px',
          left: '-100px',
          zIndex: -1
        }
      }), /*#__PURE__*/_jsx(StyledYolk, {
        src: TOP_RIGHT_YOLK,
        style: {
          top: 0,
          right: '-200px'
        }
      }), /*#__PURE__*/_jsx(StyledYolk, {
        src: BOTTOM_RIGHT_YOLK,
        style: {
          bottom: '-4px',
          right: '-200px'
        }
      })]
    }), children]
  });
};

export default SplashPageBanner;